import { WsColors } from 'wisestep-base';

export const getInitials = (name: string) => {
  if (!name) return '';
  const words = name.split(' ').filter(Boolean);
  return words
    .map((word) => word[0].toUpperCase())
    .join('')
    .slice(0, 2);
};

export const fields = [
  { label: 'Name', key: 'name' },
  { label: 'Email', key: 'email' },
  { label: 'Phone Number', key: 'phoneNumber' },
  { label: 'CV', key: 'resumeFileOriginalName' },
  { label: 'Other Documents', key: 'otherDocuments' },
  { label: 'Alternate Emails', key: 'alternateEmails' },
  { label: 'Alternate Phone Numbers', key: 'alternatePhoneNumbers' },
  { label: 'SocialLinks', key: 'linkedInURL' },
  { label: 'Candidate Skills', key: 'candidateSkills' },
  { label: 'Current Employer', key: 'currentEmployer' },
  { label: 'Current Job Title', key: 'currentJobTitle' },
  { label: 'Current Location', key: 'currentLocation' },
  { label: 'Current Job Type', key: 'currentJobType' },
  { label: 'Job Location', key: 'mappedJobLocation' },
  { label: 'Notice Period', key: 'noticePeriodInDays' },
  { label: 'Visa Status', key: 'visaStatus' },
  { label: 'Visa Validity', key: 'visaValidity' },
  { label: 'Passport Type', key: 'passportType' },
  { label: 'Passport Number', key: 'passportNumber' },
  { label: 'Candidate Notes', key: 'candidateNotes' },
  { label: 'Certifications', key: 'certifications' },
  { label: 'Citizenship', key: 'citizenship' },
  { label: 'Client Job Code', key: 'clientJobCode' },
  { label: 'Comm Preference Email', key: 'commPreferenceEmail' },
  { label: 'comm Preference Phone', key: 'commPreferencePhone' },
  { label: 'Job Preference Contract', key: 'jobPreferenceContract' },
  { label: 'Job Preference Permanent', key: 'jobPreferencePermanent' },
  { label: 'Willing To Travel', key: 'willingToTravel' },
  { label: 'Company Name', key: 'companyName' },
  { label: 'Current Salary', key: 'currentSalary' },
  { label: 'Current Salary Currency', key: 'currentSalaryCurrency' },
  { label: 'Current Salary TimeSpan', key: 'currentSalaryTimeSpan' },
  { label: 'Desired Job Titles', key: 'desiredJobTitles' },
  { label: 'DOB', key: 'dob' },
  { label: 'Education Qualifications', key: 'educationQualifications' },
  { label: 'Expected Base Salary', key: 'expectedBaseSalary' },
  { label: 'Expected Salary Currency', key: 'expectedSalaryCurrency' },
  { label: 'Expected Base Salary TimeSpan', key: 'expectedBaseSalaryTimeSpan' },
  { label: 'Experience', key: 'experience' },
  { label: 'Relocation Preference', key: 'relocationPreference' },
  { label: 'Preferred Locations', key: 'preferredLocations' },
  { label: 'Previous Employers', key: 'previousEmployers' },
  { label: 'Previous JobTitles', key: 'previousJobTitles' },
  { label: 'Tags', key: 'tags' },
  { label: 'Fax', key: 'fax' },
  { label: 'Gender', key: 'gender' },
  { label: 'Has Veteran Status', key: 'hasVeteranStatus' },
  { label: 'Interests', key: 'interests' },
  { label: 'Nationality', key: 'nationality' },
  { label: 'ProfileURLs', key: 'profileURLs' },
  { label: 'Relevant Years Experience', key: 'relevantYearsExperience' },
  { label: 'Relevant Months Experience', key: 'relevantMonthsExperience' },
  { label: 'Skills', key: 'skills' },
  { label: 'SSN Number', key: 'ssnNumber' },
  { label: 'Pan Card', key: 'panCard' },
  { label: 'Aadhar Number', key: 'aadharNumber' },
  { label: 'Age', key: 'age' },
  { label: 'Interviewing With Others', key: 'interviewingWithOthers' },
  { label: 'Personal Website', key: 'personalWebsite' },
  { label: 'Offered Pay Rate', key: 'offeredPayRate' },
  { label: 'Offered PayRate Currency', key: 'offeredPayRateCurrency' },
  { label: 'Offered PayRate TimeSpan', key: 'offeredPayRateTimeSpan' },
  { label: 'Other Current Allowances', key: 'otherCurrentAllowances' },
  { label: 'Other Expected Allowances', key: 'otherExpectedAllowances' },
  { label: 'Total Months Experience', key: 'totalMonthsExperience' },
  { label: 'Total Years Experience', key: 'totalYearsExperience' },
  { label: 'Family Wiiling To Relocate', key: 'familyWillingToRelocate' },
  { label: 'Job Includes Travel', key: 'jobIncludesTravel' },
  { label: 'Job Type', key: 'jobType' },
  { label: 'Reason For NewJob', key: 'reasonForNewJob' },
  { label: 'Willing To Relocate', key: 'willingToRelocate' },
  { label: 'Business UnitName', key: 'businessUnitName' },
  { label: 'Candidate Languages', key: 'candidateLanguages' },
  { label: 'client Bill Rate', key: 'clientBillRate' },
  { label: 'client BillRate Currency', key: 'clientBillRateCurrency' },
  { label: 'client BillRate TimeSpan', key: 'clientBillRateTimeSpan' },
  { label: 'Institutions Attended', key: 'institutionsAttended' },
  { label: 'Messengers ID', key: 'messengers' },
  { label: 'Postal Address', key: 'postalAddress' },
  { label: 'Available From', key: 'availableFrom' },
  { label: 'Skill Matrix Ratings', key: 'skillMatrixRatings' },
  { label: 'Portal Id', key: 'portalId' },
  { label: 'ExEmployeeId', key: 'exEmployeeId' },
  { label: 'ExEmployeeId', key: 'exEmployeeId' },
  { label: 'ExEmployeeOfClient', key: 'exEmployeeOfClient' },
];

export const previewStyles = {
  warningBox: {
    width: '100%',
    bgcolor: WsColors.BackGroundRed,
    borderRadius: 2,
    p: 2,
    mb: 2,
    display: 'flex',
    gap: 1.5,
  },
  warningIcon: {
    color: WsColors.DarkRed,
    fontSize: 28,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: 2,
  },
  mainGridContainer: {
    border: 1,
    borderColor: 'divider',
    borderRadius: 2,
    maxHeight: 400,
    maxWidth: '100%',
    overflowY: 'auto',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
  rowContainer: (isLastRow: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    borderBottom: isLastRow ? 0 : 1,
    borderColor: 'divider',
    flexWrap: 'nowrap',
  }),
  labelColumn: {
    bgcolor: WsColors.BorderGrey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    px: 2,
    minHeight: 60,
    wordBreak: 'break-word',
    flexShrink: 0,
  },
  valueColumn: {
    display: 'flex',
    alignItems: 'center',
    px: 2,
    minHeight: 60,
    flexShrink: 0,
  },
};

export const formatValue = (value: any) => {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  if (!value) return '';
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === 'object' && item !== null ? formatValue(item) : item))
      .join(' | ');
  }

  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([key, val]) => `${key}: ${val}`)
      .join(', ');
  }

  return value;
};
